import React, { useState } from 'react'
import AddToCartButton from '../product/AddToCartButton'
import { handleAddToCart } from '../../utils/helpers/global'
import { trackAddToCart } from '@helpers/trackCartActions'
import { doConfetti } from '../../utils/confetti'
import { Product, ProductVariant } from '../../utils/interfaces/product'

export interface SportsBeerProductCardData {
  product: Product
  currentVariant: ProductVariant
}

const SportsBeerProductCard: React.FC<SportsBeerProductCardData> = ({ product, currentVariant }) => {
  const [showVariants, setShowVariants] = useState(false)

  const hasMultipleVariants =
    !product.hasOnlyDefaultVariant && !!product.variants?.length && product.variants.length > 1

  const handleVariantClick = (e: React.MouseEvent<HTMLButtonElement>, variant: ProductVariant) => {
    handleAddToCart(variant.id, 1, variant.metafields?.relatedVariants)
    trackAddToCart(product, variant, 1)
    doConfetti(e.currentTarget)
    setShowVariants(false)
  }

  if (!hasMultipleVariants) {
    return <AddToCartButton product={product} currentVariant={currentVariant} quantity={1} />
  }

  if (showVariants) {
    return (
      <div className="flex flex-col gap-2 bg-[#3E2F3D] p-1.5">
        <p className="font-chivomono text-[11px] uppercase tracking-wider text-white">Select option:</p>
        <div className="flex flex-wrap gap-1">
          {product.variants!.map((variant) => (
            <button
              key={String(variant.id)}
              disabled={!variant.availableForSale}
              onClick={(e) => handleVariantClick(e, variant)}
              className={[
                'font-bookman text-[9px] lg:text-[13px] leading-[12px] px-2 py-1.5 text-[#3E2F3D] border-2 border-[#3E2F3D] transition-colors flex-1 rounded-3xl pt-[13px] px-2.5 pb-2.5',
                variant.availableForSale
                  ? 'bg-[#FF755A] text-[#3E2F3D]'
                  : 'bg-white text-[#3E2F3D] opacity-40 cursor-not-allowed line-through',
              ].join(' ')}
            >
              {variant.title}
            </button>
          ))}
        </div>
        <button
          onClick={() => setShowVariants(false)}
          className="font-chivomono text-[11px] underline text-white text-center"
        >Cancel</button>
      </div>
    )
  }

  return (
    <button className="sports-beer-product-btn w-full" onClick={() => setShowVariants(true)}>
      Add to Cart
    </button>
  )
}

export default SportsBeerProductCard
